<template>
  <article id="app" class="btb-app">
    <!-- <pre style="position: fixed; top: 0; left: 0; text-align: left; height: 100vh; overflow: scroll; background-color: rgba(255, 255, 255, 0.5); z-index: 999;"> -->
      <!-- SMS: {{ smsOptin }}
      BOOKER: {{ booker }}
      OCCASION: {{ occasion }}
      PERSON: {{ person }}
      PLAYER: {{ isPlayer }}
      HEARD_FROM: {{ heardFrom }}
      RESERVATION: {{ selectedReservation }}
      MINORS: {{ minors }} -->
      <!-- RESERVATIONS: {{ reservations }} -->
    <!-- </pre> -->
    <header class="btb-header text-center">
      <b-container fluid>
        <figure class="btb-logo-wrapper">
          <a href="/">
            <img class="btb-logo" src="./assets/btb.png" alt="BTB LOGO" />
          </a>
        </figure>
        <b-row class="my-2">
          <b-col>
            <h4 class="m-0">
              <span>
                {{ greeting }}
              </span>
              <span class="text-uppercase">
                {{ locationName }}
              </span>
            </h4>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col lg="10">
            <hr />
          </b-col>
        </b-row>
      </b-container>
    </header>
    <b-container class="btb-main">
      <router-view></router-view>
    </b-container>
  </article>
</template>

<script>
import VueSignature from 'vue-signature-pad';
import DropdownDatepicker from 'vue-dropdown-datepicker';
import { FETCH_GLOBAL_DATA } from './store/actions';
import { BOOKER, HEARD_FROM, MINORS, PERSON, PLAYER, SELECTED_RESERVATION, SMS_OPTIN, OCCASION, RESERVATIONS } from './store/state';
import { mapState } from 'vuex';

export default {
  name: 'AppRefresh',
  components: {
    DropdownDatepicker,
    VueSignature,
  },
  metaInfo() {
    return {
      title: `Waiver - ${ process.env.VUE_APP_LOCATION_NAME }`,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'width=device-width, initial-scale=1, shrink-to-fit=no'
        }
      ]
    };
  },
  data () {
    return {
      locationName: `${ process.env.VUE_APP_LOCATION_NAME ?? 'Beat the Bomb' }` ,
    }
  },
  computed: {
    ...mapState([
      BOOKER,
      HEARD_FROM,
      MINORS,
      OCCASION,
      PERSON,
      PLAYER,
      RESERVATIONS,
      SELECTED_RESERVATION,
      SMS_OPTIN
    ]),
    greeting () {
      return 'Welcome to';
    },

  },
  async created () {
    await this.$store.dispatch(FETCH_GLOBAL_DATA);

    /** idle for 5 min refresh the waiver **/
      var idleTime = 0;
      var idleInterval = setInterval(timerIncrement, 1000);

      function timerIncrement()
       {
         idleTime++;
         if (idleTime > 300)
         {
           doPreload();
         }
       }
       
       // mouseMove(){
       //    idleTime = 0;
       // };
       
      document.addEventListener('mousemove', event => {
        idleTime = 0;
      })

       function doPreload()
       {
          console.log('idle for 5 min , reloading the page');
          // setTimeout(location.reload.bind(location), 1);

          setTimeout(function(){ 
            window.location.href = process.env.VUE_APP_HOME_PAGE;
          }, 1);

       }
    /** end of idle code **/
  }
}
</script>

<style>
:root {
  --font-small: 0.8rem;
  --click-pad: 0.75rem;
}

input[type="radio"] {
  position: absolute;
  visibility: hidden;
}

.btn, label.btn {
  cursor: pointer;
}

.btb-form-description {
  color:red; 
  font-size: var(--font-small); 
  font-style: italic;
}

.btb-app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #fff;
  height: 100vh;

  display: flex;
  flex-direction: column;
}

.btb-datepicker select {
  padding: 6px 0.5rem;
  border: 1px solid var(--bs-gray-400);
  border-radius: 0.375rem;
}

.btb-header {
  text-align: center;
}

.btb-logo-wrapper {
  margin: 2rem auto;
  min-width: 280px;
  text-align: center;
  width: 25%;
}

.btb-logo {
  width: 100%;
}

.btb-label-lg {
  font-size: 1.2rem;
}

.btb-main {
  flex-grow: 1;
}

.btb-input-invalid {
  border-color: var(--bs-danger)
}

.form-group.is-invalid .btn-group-toggle .btn {
  border-color: var(--bs-danger);
}

.form-group.is-invalid select:invalid {
  border-color: var(--bs-danger);
}

.form-group.is-valid .btn-group-toggle .btn {
  border-color: var(--bs-success);
}

.form-group.is-valid select:valid {
  border-color: var(--bs-success);
}

label.btb-radio-button, button.list-group-item-action {
  padding-top: var(--click-pad);
  padding-bottom: var(--click-pad);
}

.font-bold {
  font-weight: 600;
}

.font-italic {
  font-style: italic;
}

.font-small {
  font-size: var(--font-small);
}

.text-center {
  text-align: center;
}
</style>